<template>
  <div class="evalua_page-root tea_create_evalua-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">{{title}}</p>
      </yioks-page-nav>
      <div class="content-wrap">
        <user :org-info="orgInfo"></user>
        <!-- <p class="evalua-tip">请根据中国足协要求，依据实际情况认真填写问卷调查，这样会有助于国家足球体育的不断进步！</p> -->
        <div class="evalua-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="$options._myOpt.vuescrollOpt">
              <div class="scroll-content">
                <div class="evaluat-box">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对机构{{orgEvaluatRes.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.starNum"></yioks-rating>
                  <div >
                    <p class="cont-title">存在以下现象</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="orgEvaluatRes.contsList"></yioks-evaluation>
                  </div>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="orgEvaluatRes.suggest"
                      rows="2"
                      placeholder="如有其他意见，请输入内容，没有意见可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{orgEvaluatRes.suggest.length}}/100</span>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="post-btn">
        <div class="btn save" @click="tipsFlag=true">提交</div>
        <div class="btn cancel" @click="goBack">取消</div>
      </div>
      <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
      <yioks-tips :showTips="tipsFlag" :tips="$options._myOpt.tipMsg" @hideTips="hideTipsDialog"></yioks-tips>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { getTeaRatingInfo, saveTeaEvaluat } from "@/api/training_teacher/api";
import { correctStatus } from "@/assets/js/apiStatus";
import { transContsList } from "@/assets/js/evaluation";
const HOSTURL = process.env.VUE_APP_URL;
const SPLIT_CHAR = ",";

export default {
  name: "TeaCreateEvaluation",
  _myOpt: {
    vuescrollOpt: createScrollOpt(),
    tipMsg: "提交后不可更改，是否确定提交？"
  },
  components: {
    "v-icon": Icon,
    user: () => import("./components/EvaluatUser"),
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-rating": () => import("@/components/Rating/Rating"),
    "yioks-evaluation": () => import("@/components/EvaluaConts/EvaluaConts"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  },
  created() {
    this.ratingInfo();
  },
  data() {
    return {
      backComfim: false,
      classId:this.$route.query.classId,
      title:this.$route.query.title,
      tipsFlag: false,
      orgInfo: {},
      orgEvaluatRes: {
        name: "",
        starNum: 0,
        suggest: "",
        contsList: []
      }
    };
  },
  methods: {
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.push({
        name: "TeaEvaluationList"
      });
      } else {
      }
    },
    // 是否确定提交数据弹窗
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        // 提交数据
        this.saveEvaluat();
      } else {
      }
    },
    saveEvaluat() {
      const { orgEvaluatRes } = this;
      if (orgEvaluatRes.starNum === 0) {
        this.$message.error("星级评价为必评项");
        return;
      }
      const orgEvalData = {
        star: orgEvaluatRes.starNum,
        other_eva: orgEvaluatRes.suggest,
        tag_list: orgEvaluatRes.contsList.map(({ id, checked }) => ({
          eva_id: id,
          is_option: checked ? 1 : 0
        }))
      };
      saveTeaEvaluat({
        org_eval_data: JSON.stringify(orgEvalData),
        c_id: this.classId
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          // Header调查数量-1
          this.$store.commit("updateEvaNum", this.$store.state.evaNum - 1);
          this.$router.push({
        name: "TeaEvaluationList"
      });
        } else {
        }
      });
    },
    ratingInfo() {
      getTeaRatingInfo({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          const { result } = data;
          const { organization, eva_data } = result;
          this.orgInfo = {
            ...organization,
            profile_picture: organization.profile_picture
              ? HOSTURL + organization.profile_picture
              : ""
          };

          this.orgEvaluatRes = {
            name: organization.name,
            starNum: 0,
            suggest: "",
            contsList: transContsList(eva_data)
          };
        } else {
        }
      });
    },
    goBack() {
      this.backComfim = true;
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluation'
</style>
